const state = {
	isShowOverlayCopilotConfig: false,
	isShowOverlayEditMenus: false,
	isShowOverlayInternalComment: false,
	isShowOverlayNewReservationPhone: false,
	isShowOverlayProductAvailabilityManager: false,
	isShowOverlayHistoricNotificationsAudio: false,
	isShowOverlayUpdatePaxAccount: false,
	isShowOverlayQRGoogle: false,
	isShowOverlayDetailsUserAccount: false,
	isShowOverlayQRAccount: false,
	isShowOverlayHistoricProductsAccount: false,
	isShowOverlayCreateSitIn: false,
	isShowOverlayNotificationsDrinksPending: false,
	isShowOverlayNotificationsPending: false,
	isShowOverlayCompleteMenuAccount: false,
	isShowOverlayConfirmRemoveProductAccount: false,
	isShowOverlayScannerQR: false,
	isShowOverlayCreateWalkIn: false,
	isShowOverlayUpdateTableAccount: false,
	isShowOverlayFinishAccount: false,
	isShowOverlaySearchAccount: false,
	isShowOverlayNotificationsReadyPayment: false,
	isShowOverlayNotificationsNewOrder: false,
	isShowOverlayNotificationsOrderReady: false,
	isShowOverlayNotificationUpsellingDrinksReminder: false,
	isShowOverlayPromotionAccount: false,
	isShowOverlayFastPaidCard: false,
	isShowOverlayFastPaidCash: false,
	isShowOverlayNotificationsAccountKiosk: false,
	isShowOverlayInformationProduct: false,
	isShowOverlayProductsCart: false,
	isShowOverlayProductComment: false,
	overlayProductCommentUseOptionsAware: false,
	isShowOverlayCommander: false,
	isShowOverlayProductMenu: false,
	isShowOverlayProductOptionBreakfasts: false,
	isShowOverlayCashRegisterClosing: false,
	isShowOverlayFinalizedReservationsKitchen: false,
	isShowOverlayAllReservationsKitchen: false,
	isShowOverlayNotificationsCallStaff: false,
	isShowOverlaySearchAccountZones: false,
	isShowOverlayPriceModify: false,
	isShowOverlayPinCodeEntry: false,
};

const getters = {
	getIsShowOverlayCopilotConfig(state) {
		return state.isShowOverlayCopilotConfig;
	},
	getIsShowOverlayEditMenus(state) {
		return state.isShowOverlayEditMenus;
	},
	getIsShowOverlayInternalComment(state) {
		return state.isShowOverlayInternalComment;
	},
	getIsShowOverlayNewReservationPhone(state) {
		return state.isShowOverlayNewReservationPhone;
	},
	getIsShowOverlayProductAvailabilityManager(state) {
		return state.isShowOverlayProductAvailabilityManager;
	},
	getIsShowOverlayHistoricNotificationsAudio(state) {
		return state.isShowOverlayHistoricNotificationsAudio;
	},
	getIsShowOverlayUpdatePaxAccount(state) {
		return state.isShowOverlayUpdatePaxAccount;
	},
	getIsShowOverlayQRGoogle(state) {
		return state.isShowOverlayQRGoogle;
	},
	getIsShowOverlayDetailsUserAccount(state) {
		return state.isShowOverlayDetailsUserAccount;
	},
	getIsShowOverlayQRAccount(state) {
		return state.isShowOverlayQRAccount;
	},
	getIsShowOverlayHistoricProductsAccount(state) {
		return state.isShowOverlayHistoricProductsAccount;
	},
	getIsShowOverlayCreateSitIn(state) {
		return state.isShowOverlayCreateSitIn;
	},
	getIsShowOverlayNotificationsDrinksPending(state) {
		return state.isShowOverlayNotificationsDrinksPending;
	},
	getIsShowOverlayNotificationsPending(state) {
		return state.isShowOverlayNotificationsPending;
	},
	getIsShowOverlayCompleteMenuAccount(state) {
		return state.isShowOverlayCompleteMenuAccount;
	},
	getIsShowOverlayConfirmRemoveProductAccount(state) {
		return state.isShowOverlayConfirmRemoveProductAccount;
	},
	getIsShowOverlayScannerQR(state) {
		return state.isShowOverlayScannerQR;
	},
	getIsShowOverlayCreateWalkIn(state) {
		return state.isShowOverlayCreateWalkIn;
	},
	getIsShowOverlayUpdateTableAccount(state) {
		return state.isShowOverlayUpdateTableAccount;
	},
	getIsShowOverlayFinishAccount(state) {
		return state.isShowOverlayFinishAccount;
	},
	getIsShowOverlaySearchAccount(state) {
		return state.isShowOverlaySearchAccount;
	},
	getIsShowOverlayNotificationsReadyPayment(state) {
		return state.isShowOverlayNotificationsReadyPayment;
	},
	getIsShowOverlayNotificationsNewOrder(state) {
		return state.isShowOverlayNotificationsNewOrder;
	},
	getIsShowOverlayNotificationsOrderReady(state) {
		return state.isShowOverlayNotificationsOrderReady;
	},
	getIsShowOverlayNotificationUpsellingDrinksReminder(state) {
		return state.isShowOverlayNotificationUpsellingDrinksReminder;
	},
	getIsShowOverlayPromotionAccount(state) {
		return state.isShowOverlayPromotionAccount;
	},
	getIsShowOverlayFastPaidCard(state) {
		return state.isShowOverlayFastPaidCard;
	},
	getIsShowOverlayFastPaidCash(state) {
		return state.isShowOverlayFastPaidCash;
	},
	getIsShowOverlayNotificationsAccountKiosk(state) {
		return state.isShowOverlayNotificationsAccountKiosk;
	},
	getIsShowOverlayInformationProduct(state) {
		return state.isShowOverlayInformationProduct;
	},

	getIsShowOverlayProductMenu(state) {
		return state.isShowOverlayProductMenu;
	},

	getIsShowOverlayProductsCart(state) {
		return state.isShowOverlayProductsCart;
	},
	getIsShowOverlayProductComment(state) {
		return state.isShowOverlayProductComment;
	},
	getOverlayProductCommentUseOptionsAware(state) {
		return state.overlayProductCommentUseOptionsAware;
	},
	getIsShowOverlayCommander(state) {
		return state.isShowOverlayCommander;
	},
	getIsShowProductMenu(state) {
		return state.isShowOverlayProductMenu;
	},
	getIsShowProductOptionBreakfasts(state) {
		return state.isShowOverlayProductOptionBreakfasts;
	},
	getIsShowCashRegisterClosing(state) {
		return state.isShowOverlayCashRegisterClosing;
	},
	getIsShowFinalizedReservationsKitchen(state) {
		return state.isShowOverlayFinalizedReservationsKitchen;
	},
	getIsShowAllReservationsKitchen(state) {
		return state.isShowOverlayAllReservationsKitchen;
	},
	getIsShowOverlayNotificationsCallStaff(state) {
		return state.isShowOverlayNotificationsCallStaff;
	},
	getIsShowOverlaySearchAccountZones(state) {
		return state.isShowOverlaySearchAccountZones;
	},
	getIsShowOverlayPriceModify(state) {
		return state.isShowOverlayPriceModify;
	},
	getIsShowOverlayPinCodeEntry(state) {
		return state.isShowOverlayPinCodeEntry;
	},
};

const mutations = {
	SET_IS_SHOW_OVERLAY_COPILOT_CONFIG(state, payload) {
		state.isShowOverlayCopilotConfig = payload;
	},
	SET_IS_SHOW_OVERLAY_EDIT_MENUS(state, payload) {
		state.isShowOverlayEditMenus = payload;
	},
	SET_IS_SHOW_OVERLAY_INTERNAL_COMMENT(state, payload) {
		state.isShowOverlayInternalComment = payload;
	},
	SET_IS_SHOW_OVERLAY_NEW_RESERVATION_PHONE(state, payload) {
		state.isShowOverlayNewReservationPhone = payload;
	},
	SET_IS_SHOW_OVERLAY_PRODUCT_AVAILABILITY_MANAGER(state, payload) {
		state.isShowOverlayProductAvailabilityManager = payload;
	},
	SET_IS_SHOW_OVERLAY_HISTORIC_NOTIFICATIONS_AUDIO(state, payload) {
		state.isShowOverlayHistoricNotificationsAudio = payload;
	},
	SET_IS_SHOW_OVERLAY_UPDATE_PAX_ACCOUNT(state, payload) {
		state.isShowOverlayUpdatePaxAccount = payload;
	},
	SET_IS_SHOW_OVERLAY_QR_GOOGLE(state, payload) {
		state.isShowOverlayQRGoogle = payload;
	},
	SET_IS_SHOW_OVERLAY_DETAILS_USER_ACCOUNT(state, payload) {
		state.isShowOverlayDetailsUserAccount = payload;
	},
	SET_IS_SHOW_OVERLAY_QR_ACCOUNT(state, payload) {
		state.isShowOverlayQRAccount = payload;
	},
	SET_IS_SHOW_OVERLAY_HISTORIC_PRODUCTS_ACCOUNT(state, payload) {
		state.isShowOverlayHistoricProductsAccount = payload;
	},
	SET_IS_SHOW_OVERLAY_CREATE_SIT_IN(state, payload) {
		state.isShowOverlayCreateSitIn = payload;
	},
	SET_IS_SHOW_OVERLAY_NOTIFICATIONS_DRINKS_PENDING(state, payload) {
		state.isShowOverlayNotificationsDrinksPending = payload;
	},
	SET_IS_SHOW_OVERLAY_NOTIFICATIONS_PENDING(state, payload) {
		state.isShowOverlayNotificationsPending = payload;
	},
	SET_IS_SHOW_OVERLAY_COMPLETE_MENU_ACCOUNT(state, payload) {
		state.isShowOverlayCompleteMenuAccount = payload;
	},
	SET_IS_SHOW_OVERLAY_CONFIRM_REMOVE_PRODUCT_ACCOUNT(state, payload) {
		state.isShowOverlayConfirmRemoveProductAccount = payload;
	},
	SET_IS_SHOW_OVERLAY_SCANNER_QR(state, payload) {
		state.isShowOverlayScannerQR = payload;
	},
	SET_IS_SHOW_OVERLAY_CREATE_WALK_IN(state, payload) {
		state.isShowOverlayCreateWalkIn = payload;
	},
	SET_IS_SHOW_OVERLAY_UPDATE_TABLE_ACCOUNT(state, payload) {
		state.isShowOverlayUpdateTableAccount = payload;
	},
	SET_IS_SHOW_OVERLAY_FINISH_ACCOUNT(state, payload) {
		state.isShowOverlayFinishAccount = payload;
	},
	SET_IS_SHOW_OVERLAY_SEARCH_ACCOUNT(state, payload) {
		state.isShowOverlaySearchAccount = payload;
	},
	SET_IS_SHOW_OVERLAY_NOTIFICATIONS_READY_PAYMENT(state, payload) {
		state.isShowOverlayNotificationsReadyPayment = payload;
	},
	SET_IS_SHOW_OVERLAY_NEW_ORDER(state, payload) {
		state.isShowOverlayNotificationsNewOrder = payload;
	},
	SET_IS_SHOW_OVERLAY_ORDER_READY(state, payload) {
		state.isShowOverlayNotificationsOrderReady = payload;
	},
	SET_IS_SHOW_OVERLAY_NOTIFICATIONS_UPSELLING_DRINKS_REMINDER(state, payload) {
		state.isShowOverlayNotificationUpsellingDrinksReminder = payload;
	},
	SET_IS_SHOW_OVERLAY_PROMOTION_ACCOUNT(state, payload) {
		state.isShowOverlayPromotionAccount = payload;
	},
	SET_IS_SHOW_OVERLAY_FAST_PAID_CARD(state, payload) {
		state.isShowOverlayFastPaidCard = payload;
	},
	SET_IS_SHOW_OVERLAY_FAST_PAID_CASH(state, payload) {
		state.isShowOverlayFastPaidCash = payload;
	},
	SET_IS_SHOW_OVERLAY_NOTIFICATIONS_ACCOUNT_KIOSK(state, payload) {
		state.isShowOverlayNotificationsAccountKiosk = payload;
	},
	SET_IS_SHOW_OVERLAY_INFORMATION_PRODUCT(state, payload) {
		state.isShowOverlayInformationProduct = payload;
	},
	SET_IS_SHOW_OVERLAY_PRODUCTS_CART(state, payload) {
		state.isShowOverlayProductsCart = payload;
	},
	SET_IS_SHOW_OVERLAY_PRODUCT_COMMENT(state, payload) {
		state.isShowOverlayProductComment = payload;
	},
	SET_OVERLAY_PRODUCT_COMMENT_USE_OPTIONS_AWARE(state, payload) {
		state.overlayProductCommentUseOptionsAware = payload;
	},
	SET_IS_SHOW_OVERLAY_COMMANDER(state, payload) {
		state.isShowOverlayCommander = payload;
	},
	SET_IS_SHOW_OVERLAY_PRODUCT_MENU(state, payload) {
		state.isShowOverlayProductMenu = payload;
	},
	SET_IS_SHOW_OVERLAY_PRODUCT_OPTION_BREAKFAST(state, payload) {
		state.isShowOverlayProductOptionBreakfasts = payload;
	},
	SET_IS_SHOW_OVERLAY_CASH_REGISTER_CLOSING(state, payload) {
		state.isShowOverlayCashRegisterClosing = payload;
	},
	SET_IS_SHOW_OVERLAY_FINALIZED_RESERVATIONS_KITCHEN(state, payload) {
		state.isShowOverlayFinalizedReservationsKitchen = payload;
	},
	SET_IS_SHOW_OVERLAY_ALL_RESERVATIONS_KITCHEN(state, payload) {
		state.isShowOverlayAllReservationsKitchen = payload;
	},
	SET_IS_SHOW_OVERLAY_NOTIFICATIONS_CALL_STAFF(state, payload) {
		state.isShowOverlayNotificationsCallStaff = payload;
	},
	SET_IS_SHOW_OVERLAY_SEARCH_ACCOUNT_ZONES(state, payload) {
		state.isShowOverlaySearchAccountZones = payload;
	},
	SET_IS_SHOW_OVERLAY_PRICE_MODIFY(state, payload) {
		state.isShowOverlayPriceModify = payload;
	},
	SET_IS_SHOW_OVERLAY_PIN_CODE_ENTRY(state, payload) {
		state.isShowOverlayPinCodeEntry = payload;
	},
};

const actions = {
	setIsShowOverlayCopilotConfig({ commit }, payload) {
		commit("SET_IS_SHOW_OVERLAY_COPILOT_CONFIG", payload);
	},
	setIsShowOverlayEditMenus({ commit }, payload) {
		commit("SET_IS_SHOW_OVERLAY_EDIT_MENUS", payload);
	},
	setIsShowOverlayInternalComment({ commit }, payload) {
		commit("SET_IS_SHOW_OVERLAY_INTERNAL_COMMENT", payload);
	},
	setIsShowOverlayNewReservationPhone({ commit }, payload) {
		commit("SET_IS_SHOW_OVERLAY_NEW_RESERVATION_PHONE", payload);
	},
	setIsShowOverlayProductAvailabilityManager({ commit }, payload) {
		commit("SET_IS_SHOW_OVERLAY_PRODUCT_AVAILABILITY_MANAGER", payload);
	},
	setIsShowOverlayHistoricNotificationsAudio({ commit }, payload) {
		commit("SET_IS_SHOW_OVERLAY_HISTORIC_NOTIFICATIONS_AUDIO", payload);
	},
	setIsShowOverlayUpdatePaxAccount({ commit }, payload) {
		commit("SET_IS_SHOW_OVERLAY_UPDATE_PAX_ACCOUNT", payload);
	},
	setIsShowOverlayQRGoogle({ commit }, payload) {
		commit("SET_IS_SHOW_OVERLAY_QR_GOOGLE", payload);
	},
	setIsShowOverlayDetailsUserAccount({ commit }, payload) {
		commit("SET_IS_SHOW_OVERLAY_DETAILS_USER_ACCOUNT", payload);
	},
	setIsShowOverlayQRAccount({ commit }, payload) {
		commit("SET_IS_SHOW_OVERLAY_QR_ACCOUNT", payload);
	},
	setIsShowOverlayHistoricProductsAccount({ commit }, payload) {
		commit("SET_IS_SHOW_OVERLAY_HISTORIC_PRODUCTS_ACCOUNT", payload);
	},
	setIsShowOverlayCreateSitIn({ commit }, payload) {
		commit("SET_IS_SHOW_OVERLAY_CREATE_SIT_IN", payload);
	},
	setIsShowOverlayNotificationsDrinksPending({ commit }, payload) {
		commit("SET_IS_SHOW_OVERLAY_NOTIFICATIONS_DRINKS_PENDING", payload);
	},
	setIsShowOverlayNotificationsPending({ commit }, payload) {
		commit("SET_IS_SHOW_OVERLAY_NOTIFICATIONS_PENDING", payload);
	},
	setIsShowOverlayCompleteMenuAccount({ commit }, payload) {
		commit("SET_IS_SHOW_OVERLAY_COMPLETE_MENU_ACCOUNT", payload);
	},
	setIsShowOverlayConfirmRemoveProductAccount({ commit }, payload) {
		commit("SET_IS_SHOW_OVERLAY_CONFIRM_REMOVE_PRODUCT_ACCOUNT", payload);
	},
	setIsShowOverlayScannerQR({ commit }, payload) {
		commit("SET_IS_SHOW_OVERLAY_SCANNER_QR", payload);
	},
	setIsShowOverlayCreateWalkIn({ commit }, payload) {
		commit("SET_IS_SHOW_OVERLAY_CREATE_WALK_IN", payload);
	},
	setIsShowOverlayUpdateTableAccount({ commit }, payload) {
		commit("SET_IS_SHOW_OVERLAY_UPDATE_TABLE_ACCOUNT", payload);
	},
	setIsShowOverlayFinishAccount({ commit }, payload) {
		commit("SET_IS_SHOW_OVERLAY_FINISH_ACCOUNT", payload);
	},
	setIsShowOverlaySearchAccount({ commit }, payload) {
		commit("SET_IS_SHOW_OVERLAY_SEARCH_ACCOUNT", payload);
	},
	setIsShowOverlayNotificationsReadyPayment({ commit }, payload) {
		commit("SET_IS_SHOW_OVERLAY_NOTIFICATIONS_READY_PAYMENT", payload);
	},
	setIsShowOverlayNotificationsNewOrder({ commit }, payload) {
		commit("SET_IS_SHOW_OVERLAY_NEW_ORDER", payload);
	},
	setIsShowOverlayNotificationsOrderReady({ commit }, payload) {
		commit("SET_IS_SHOW_OVERLAY_ORDER_READY", payload);
	},
	setIsShowOverlayNotificationUpsellingDrinksReminder({ commit }, payload) {
		commit("SET_IS_SHOW_OVERLAY_NOTIFICATIONS_UPSELLING_DRINKS_REMINDER", payload);
	},
	setIsShowOverlayPromotionAccount({ commit }, payload) {
		commit("SET_IS_SHOW_OVERLAY_PROMOTION_ACCOUNT", payload);
	},
	setIsShowOverlayFastPaidCard({ commit }, payload) {
		commit("SET_IS_SHOW_OVERLAY_FAST_PAID_CARD", payload);
	},
	setIsShowOverlayFastPaidCash({ commit }, payload) {
		commit("SET_IS_SHOW_OVERLAY_FAST_PAID_CASH", payload);
	},
	setIsShowOverlayNotificationsAccountKiosk({ commit }, payload) {
		commit("SET_IS_SHOW_OVERLAY_NOTIFICATIONS_ACCOUNT_KIOSK", payload);
	},
	setIsShowOverlayInformationProduct({ commit }, payload) {
		commit("SET_IS_SHOW_OVERLAY_INFORMATION_PRODUCT", payload);
	},
	setIsShowOverlayProductsCart({ commit }, payload) {
		commit("SET_IS_SHOW_OVERLAY_PRODUCTS_CART", payload);
	},
	setIsShowOverlayProductComment({ commit }, payload) {
		commit("SET_IS_SHOW_OVERLAY_PRODUCT_COMMENT", payload);
	},
	setOverlayProductCommentUseOptionsAware({ commit }, payload) {
		commit("SET_OVERLAY_PRODUCT_COMMENT_USE_OPTIONS_AWARE", payload);
	},
	setIsShowOverlayCommander({ commit }, payload) {
		commit("SET_IS_SHOW_OVERLAY_COMMANDER", payload);
	},
	setIsShowOverlayProductMenu({ commit }, payload) {
		commit("SET_IS_SHOW_OVERLAY_PRODUCT_MENU", payload);
	},
	setIsShowOverlayProductOptionBreakfast({ commit }, payload) {
		commit("SET_IS_SHOW_OVERLAY_PRODUCT_OPTION_BREAKFAST", payload);
	},
	setIsShowOverlayCashRegisterClosing({ commit }, payload) {
		commit("SET_IS_SHOW_OVERLAY_CASH_REGISTER_CLOSING", payload);
	},
	setIsShowOverlayFinalizedReservationsKitchen({ commit }, payload) {
		commit("SET_IS_SHOW_OVERLAY_FINALIZED_RESERVATIONS_KITCHEN", payload);
	},
	setIsShowOverlayAllReservationsKitchen({ commit }, payload) {
		commit("SET_IS_SHOW_OVERLAY_ALL_RESERVATIONS_KITCHEN", payload);
	},
	setIsShowOverlayNotificationsCallStaff({ commit }, payload) {
		commit("SET_IS_SHOW_OVERLAY_NOTIFICATIONS_CALL_STAFF", payload);
	},
	setIsShowOverlaySearchAccountZones({ commit }, payload) {
		commit("SET_IS_SHOW_OVERLAY_SEARCH_ACCOUNT_ZONES", payload);
	},
	setIsShowOverlayPriceModify({ commit }, payload) {
		commit("SET_IS_SHOW_OVERLAY_PRICE_MODIFY", payload);
	},
	setIsShowOverlayPinCodeEntry({ commit }, payload) {
		commit("SET_IS_SHOW_OVERLAY_PIN_CODE_ENTRY", payload);
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};
